<script setup lang="ts">
import { ref } from 'vue'
import type { FightDamageRankType } from '@/types/rank'
import { socketEmitAsync } from '@/utils/web-socket'
import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import { onMounted } from 'vue'
import { formatNumberWithCommas } from '@/utils'

const commonStore = useCommonStore()
const userStore = useUserStore()

const rankList = ref<FightDamageRankType[]>([])
async function getFightDamageRank() {
  const res = await socketEmitAsync<FightDamageRankType[]>({ type: 'getYesterdayPeakDamageRank' })
  rankList.value = res
}

onMounted(() => {
  getFightDamageRank()
})
</script>

<template>
  <el-table
    :data="rankList"
    border
    style="width: 100%; height: 100%"
    :row-class-name="({ row }: any) => (row.id === userStore.id ? 'personal' : '')"
    size="small"
    v-loading="commonStore.loading"
  >
    <el-table-column prop="rank" label="排位" width="50"> </el-table-column>
    <el-table-column prop="nickname" label="昵称">
      <template #default="{ row }">
        <span class="nickname" :style="{ background: row.color }">{{ row.nickname }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="damage" label="总伤害" width="120">
      <template #default="{ row }">
        <span>{{ formatNumberWithCommas(row.damage) }}</span>
      </template></el-table-column
    >
  </el-table>
</template>

<style lang="scss" scoped></style>
